import { useQuery } from "@tanstack/react-query";
import { getOrganisationSettings } from "@/api/settings";
import { useAuthStore } from "./useAuth";
import { useEffect } from "react";

export const useOrganisationSettings = () => {
  const { organisationSettings, setOrganisationSettings, currentOrganisation } =
    useAuthStore();

  const { data } = useQuery({
    queryKey: ["organisation-settings", currentOrganisation?.id],
    queryFn: getOrganisationSettings,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!currentOrganisation,
  });

  useEffect(() => {
    if (data) {
      setOrganisationSettings(data);
    }
  }, [data, setOrganisationSettings]);

  return organisationSettings ?? data ?? null;
};
